import { render, staticRenderFns } from "./assessBox.vue?vue&type=template&id=368aa0ea&scoped=true"
import script from "./assessBox.vue?vue&type=script&lang=js"
export * from "./assessBox.vue?vue&type=script&lang=js"
import style0 from "./assessBox.vue?vue&type=style&index=0&id=368aa0ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368aa0ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('368aa0ea')) {
      api.createRecord('368aa0ea', component.options)
    } else {
      api.reload('368aa0ea', component.options)
    }
    module.hot.accept("./assessBox.vue?vue&type=template&id=368aa0ea&scoped=true", function () {
      api.rerender('368aa0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/assess/config/components/assessBox.vue"
export default component.exports